var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPhoto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.667H10A3.333 3.333 0 006.667 10v20A3.333 3.333 0 0010 33.333h20A3.333 3.333 0 0033.333 30V10A3.333 3.333 0 0030 6.667z",
    stroke: "#171E37",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 15.833a1.667 1.667 0 100-3.333 1.667 1.667 0 000 3.333zM8.334 31.667L17.08 21.46a1.667 1.667 0 012.52-.012L30 33.334m-7.5-9.168l3.829-4.466a1.667 1.667 0 012.444-.094l4.56 4.56",
    stroke: "#171E37",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/noPhoto.59f92e939f2a0b1c4f602274dda27ad0.svg";
export { ForwardRef as ReactComponent };